import {
   getDateByDayStart,
   getDateByDayEnd,
   toStringDate,
} from 'util/dateUtil';

const TODAY = getDateByDayStart(new Date());
const YESTERDAY = ((d) => new Date(d.setDate(d.getDate() - 1)))(new Date());
const SEVEN_DAYS_AGO = ((d) => new Date(d.setDate(d.getDate() - 7)))(new Date());
const THIRTY_DAYS_AGO = ((d) => new Date(d.setDate(d.getDate() - 30)))(new Date());
const FIVE_YEARS_AGO = ((d) => new Date(d.setDate(d.getDate() - 1825)))(new Date());

const getToday = () => {
   const date = new Date();
   return getDateByDayStart(date);
};
const getYesterday = () => (((d) => new Date(d.setDate(d.getDate() - 1)))(getToday()));
const getSevenDaysAgo = () => (((d) => new Date(d.setDate(d.getDate() - 7)))(getToday()));
const getThirtyDaysAgo = () => (((d) => new Date(d.setDate(d.getDate() - 30)))(getToday()));
const getFiveYearsAgo = () => (((d) => new Date(d.setDate(d.getDate() - 1825)))(getToday()));

const date = {
   today: {
      start: TODAY,
      end: getDateByDayEnd(TODAY),
      getDate: () => TODAY,
      getDateStr: () => toStringDate(TODAY),
      getDayStart: () => TODAY,
      getDayEnd: () => getDateByDayEnd(TODAY),
   },
   yesterday: {
      start: getDateByDayStart(YESTERDAY),
      end: getDateByDayEnd(YESTERDAY),
      getDate: () => getYesterday(),
      getDateStr: () => toStringDate(getYesterday()),
      getDayStart: () => (getDateByDayStart(getYesterday())),
      getDayEnd: () => (getDateByDayEnd(getYesterday())),
   },
   sevenDaysAgo: {
      start: getDateByDayStart(SEVEN_DAYS_AGO),
      end: getDateByDayEnd(SEVEN_DAYS_AGO),
      getDate: () => getSevenDaysAgo(),
      getDateStr: () => toStringDate(getSevenDaysAgo()),
      getDayStart: () => (getDateByDayStart(getSevenDaysAgo())),
      getDayEnd: () => (getDateByDayEnd(getToday())),
   },
   thirtyDaysAgo: {
      start: getDateByDayStart(THIRTY_DAYS_AGO),
      end: getDateByDayEnd(THIRTY_DAYS_AGO),
      getDate: () => getThirtyDaysAgo(),
      getDateStr: () => toStringDate(getThirtyDaysAgo()),
      getDayStart: () => (getDateByDayStart(getThirtyDaysAgo())),
      getDayEnd: () => (getDateByDayEnd(getToday())),
   },
   fiveYearsAgo: {
      start: getDateByDayStart(FIVE_YEARS_AGO),
      end: getDateByDayEnd(FIVE_YEARS_AGO),
      getDate: () => getFiveYearsAgo(),
      getDateStr: () => toStringDate(getFiveYearsAgo()),
      getDayStart: () => (getDateByDayStart(getFiveYearsAgo())),
      getDayEnd: () => (getDateByDayEnd(getToday())),
   },
};

export default date;
